import React from 'react';
import { ReactComponent as Logo } from '../images/logo.svg';
import { Link as RouterLink } from 'react-router-dom';
import { getRouteByName } from '../router/routes';
import { Button } from '../components/ui';

interface Props {}

const NotFoundPage: React.FC<Props> = () => {
  return (
    <div className="bg-gray-100 flex flex-col items-center justify-center min-h-screen text-center px-4">
      <div className="mb-4">
        <Logo />
      </div>
      <p className="text-2xl md:text-3xl font-light text-gray-700 mt-4">
        Sorry, we couldn't find the page you're looking for.
      </p>
      <div className="mt-6">
        <RouterLink to={getRouteByName('RouteConferences').path}>
          <Button>Go back home</Button>
        </RouterLink>
      </div>
    </div>
  );
};

export default NotFoundPage;
